// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LeftCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/LeftCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var LeftCircleOutlined = function LeftCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LeftCircleOutlinedSvg
  }));
};

LeftCircleOutlined.displayName = 'LeftCircleOutlined';
export default React.forwardRef(LeftCircleOutlined);